import React from "react"
import styled from "styled-components"
import NextImg from "@/common/components/NextImg"
import C1 from "@/common/assets/image/moneyFortune/circles/Circle1.svg"
import C2 from "@/common/assets/image/moneyFortune/circles/Circle2.svg"
import C3 from "@/common/assets/image/moneyFortune/circles/Circle3.svg"
import C4 from "@/common/assets/image/moneyFortune/circles/Circle4.svg"

export default function Role({ img }) {
  return (
    <Wrapper>
      <CirclesWrapper>
        <div className="circle c1">
          <ImageWrapper>
            <NextImg src={C1} />
          </ImageWrapper>
        </div>
        <div className="circle c2">
          <ImageWrapper>
            <NextImg src={C2} />
          </ImageWrapper>
        </div>
        <div className="circle c3">
          <ImageWrapper>
            <NextImg src={C3} />
          </ImageWrapper>
        </div>
        <div className="circle c4">
          <ImageWrapper>
            <NextImg src={C4} />
          </ImageWrapper>
        </div>
      </CirclesWrapper>
      <RoleWrapper>
        <CircleImageWrapper>
          <NextImg src={img} />
        </CircleImageWrapper>
      </RoleWrapper>
    </Wrapper>
  )
}
const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`
const ImageWrapper = styled.div`
  width: 100%;
  position: relative;
`
const CircleImageWrapper = styled.div`
  width: 100%;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
`
const RoleWrapper = styled.div`
  width: 65%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

const CirclesWrapper = styled.div`
  position: absolute;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden;
  will-change: transform;
  .circle {
    position: absolute;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  @keyframes circleSpin {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotate(-360deg);
    }
  }

  .c1 {
    animation: circleSpin 12s infinite linear;
  }
  .c2 {
    animation: circleSpin 3s infinite linear;
  }
  .c3 {
    animation: circleSpin 12s infinite linear;
  }
  .c4 {
    animation: circleSpin 5s infinite linear reverse;
  }
`
